import { useCallback, useMemo, useState, type ReactNode } from 'react';

import { PromoSlotContext, type PromoSlotContextValue, type PromoSlotEntry } from './use-promo-slot-entry';

export const GlobalPromoSlot = ({ children }: { children: ReactNode }) => {
  const [entries, setEntries] = useState<Map<string, PromoSlotEntry>>(new Map());

  const registerEntry = useCallback((entry: PromoSlotEntry) => {
    setEntries((prev) => new Map(prev).set(entry.id, entry));
    return () => {
      setEntries((prev) => {
        const next = new Map(prev);
        next.delete(entry.id);
        return next;
      });
    };
  }, []);

  const activeEntryId = useMemo(() => {
    let activeId: string | null = null;
    let activePriority = Number.NEGATIVE_INFINITY;
    entries.forEach((entry) => {
      if (!entry.shouldShow) return;
      if (entry.priority > activePriority) {
        activePriority = entry.priority;
        activeId = entry.id;
      }
    });
    return activeId;
  }, [entries]);

  const contextValue = useMemo<PromoSlotContextValue>(() => ({ registerEntry, activeEntryId }), [registerEntry, activeEntryId]);

  return <PromoSlotContext.Provider value={contextValue}>{children}</PromoSlotContext.Provider>;
};
